<template>
  <div class="layout-box">
    <LayoutHeader headtitle="云商城"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="new-detail">
        <div class="new-detail-content">
          <img src="../../assets/img/hy.jpg"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";

export default {
  name: 'CloudMall',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      mapdatas:'',
      names:''
    }
  },
  mounted () {
    this.mapdatas=require('../../assets/img/'+localStorage.getItem('mapdata')+'.png')
    this.names=localStorage.getItem('mapdataname')
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}


.secondary-content{
  width: 1400px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.new-detail{
  padding: 2px 12px;
  height: calc(100% - 1px);
}

.new-detail-content{
  width: 100%;
  background: #EFF4F8;
}

.new-detail-content img{
  width: 100%;
  display: inline-block;
  margin: 10px auto;
}


</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-cloudmall-details.vue